type ConciergeIndicatorSettings = {
  externalRegister?: {
    conciergeIndicator?: {
      tenantAllowed?: boolean;
      enabled?: boolean;
    };
  };
};

export function canRenderConciergeExternalRegisterIndicator({
  isConciergeMode,
  settings,
}: {
  isConciergeMode?: boolean;
  settings?: ConciergeIndicatorSettings | null;
}): boolean {
  const buildAllowed =
    import.meta.env.VITE_ALLOW_EXTERNAL_REGISTER_CONCIERGE_INDICATOR === "true";
  const tenantAllowed = settings?.externalRegister?.conciergeIndicator?.tenantAllowed === true;
  const runtimeEnabled = settings?.externalRegister?.conciergeIndicator?.enabled === true;

  return buildAllowed && tenantAllowed && runtimeEnabled && isConciergeMode === true;
}

export function canRenderExternalRegisterDotIndicator({
  isConciergeMode,
  settings,
}: {
  isConciergeMode?: boolean;
  settings?: ConciergeIndicatorSettings | null;
}): boolean {
  if (isConciergeMode === true) {
    return canRenderConciergeExternalRegisterIndicator({ isConciergeMode, settings });
  }

  return true;
}

export function canRenderExternalRegisterClinicalIndicator({
  isConciergeMode,
}: {
  isConciergeMode?: boolean;
}): boolean {
  return isConciergeMode !== true;
}

export function canOpenExternalRegisterDetails({
  isConciergeMode,
}: {
  isConciergeMode?: boolean;
}): boolean {
  return isConciergeMode !== true;
}
